export default "__VITE_ASSET__BbOh4hVb__"